/**
 * Kubek na kości — rysowany kodem, bez jednego bajtu przez LTE.
 *
 * Trapez z zaokrąglonym rantem, malowany tokenami `--perudo-kubek`
 * i `--perudo-kubek-cien`. Skaluje się do wszystkich rozmiarów, w jakich
 * występuje (rząd graczy ~28 px, kubek w odkryciu ~72 px), działa offline od
 * pierwszego uruchomienia i bierze kolory z motywu — zdjęcie kubka nie robi
 * żadnej z tych rzeczy.
 *
 * Cały rysunek dostaje `pointerEvents: "none"`. W Catanie tekstura heksu
 * przechwytywała dotknięcie zamiast wielokąta pod spodem i złodzieja nie dało
 * się przestawić; tutaj kubek leży nad polem gracza, które bywa klikalne.
 */
export function Kubek({
  uniesiony = false,
  rozmiar = "zwykly",
}: {
  /** Ostatnia klatka odkrycia: kubek przechylony, widać ciemne wnętrze. */
  uniesiony?: boolean;
  rozmiar?: "mikro" | "zwykly";
}) {
  const bok = rozmiar === "mikro" ? "1.75rem" : "4.5rem";

  return (
    <svg
      viewBox="0 0 100 100"
      width={bok}
      height={bok}
      aria-hidden="true"
      style={{ pointerEvents: "none" }}
      className={uniesiony ? "-rotate-12 transition-transform" : "transition-transform"}
    >
      {/* Cień pod rantem — tylko pod nim, żeby kubek stał, a nie unosił się. */}
      <ellipse cx="50" cy="86" rx="31" ry="6" fill="var(--perudo-kubek-cien)" opacity="0.5" />
      <path
        d="M34 16 h32 a4 4 0 0 1 4 4 l10 62 a6 6 0 0 1 -6 7 h-48 a6 6 0 0 1 -6 -7 l10 -62 a4 4 0 0 1 4 -4 z"
        fill="var(--perudo-kubek)"
      />
      {/* Szew wzdłuż boku i przetarty rant: dwa akcenty, które robią ze skóry skórę. */}
      <path d="M50 18 v66" stroke="var(--perudo-kubek-cien)" strokeWidth="1.5" opacity="0.5" />
      {uniesiony ? (
        <ellipse cx="50" cy="84" rx="27" ry="7" fill="var(--perudo-kubek-cien)" />
      ) : (
        <rect x="22" y="78" width="56" height="6" rx="3" fill="var(--perudo-kubek-cien)" />
      )}
    </svg>
  );
}
